import { render } from "./GroupRightComponent.vue?vue&type=template&id=696fb85c&scoped=true"
import script from "./GroupRightComponent.vue?vue&type=script&lang=js"
export * from "./GroupRightComponent.vue?vue&type=script&lang=js"

import "./GroupRightComponent.vue?vue&type=style&index=0&id=696fb85c&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696fb85c"]])

export default __exports__